import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clipboard-2, copy, list"} maskId="square-filled-radius-0-stroke-1-IconClipboard2"><path fillRule="evenodd" clipRule="evenodd" d="M17 2H7V4H3V22H21V4H17V2ZM16 3H8V6H16V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClipboard2;
